<script setup lang="ts"></script>

<template>
  <!-- @vue-ignore -->
  <app-input type="number">
    <slot></slot>
  </app-input>
</template>
